import {
    type EditEventResponseType,
    type EditEventRequestType
} from "./type";
import {
    request
} from "../request";

const EditEvent = async (params: EditEventRequestType): Promise<EditEventResponseType> => {
    return await request<EditEventResponseType>("/events/editEvent", {
        body: JSON.stringify(params),
        method: "PUT"
    });
};

export default EditEvent;
